import React, {useEffect, useState} from "react";
import {useParams, useRouteMatch} from "react-router-dom";

export function withRouter(Component) {
    return function WrappedComponent(props) {

        const isPreBoarding = useRouteMatch('/:orgId/preboarding/register')?.isExact || useRouteMatch('/:orgId/preboarding/login')?.isExact || useRouteMatch('/:orgId/preboarding/forgot-password')?.isExact || useRouteMatch('/:orgId/preboarding/reset/:code')?.isExact || useRouteMatch('/:orgId/preboarding/email-sent')?.isExact;
        const isOnboarding = useRouteMatch('/:orgId/register')?.isExact || useRouteMatch('/:orgId/login')?.isExact || useRouteMatch('/:orgId/forgot-password')?.isExact || useRouteMatch('/:orgId/reset/:code')?.isExact || useRouteMatch('/:orgId/email-sent')?.isExact;
        const {orgId} = useParams();
        return <Component {...props} projectRoutes={(() => {
            if (orgId && isPreBoarding) {
                /** Preboarding **/
                return {
                    isPreBoarding,
                    isOnboarding,
                    orgId,
                    register: `/${orgId}/preboarding/register`,
                    login: `/${orgId}/preboarding/login`,
                    forgot: `/${orgId}/preboarding/forgot-password`,
                    email: `/${orgId}/preboarding/email-sent`,
                    reset: `/${orgId}/preboarding/reset/:code`,
                }
            } else if (orgId) {
                /** By Default Onboarding user Will */
                return {
                    isPreBoarding,
                    isOnboarding,
                    orgId,
                    register: `/${orgId}/register`,
                    login: `/${orgId}/login`,
                    forgot: `/${orgId}/forgot-password`,
                    email: `/${orgId}/email-sent`,
                    reset: `/${orgId}/reset/:code`,
                };
            }
             else {
                return {
                    isPreBoarding,
                    isOnboarding,
                    orgId,
                    login: "/login",
                    multiFactorAuthenticate: "/multi-factor-authenticate",
                    setupMultiFactor: "/setup-multi-factor",
                    recoveryCode: "/recovery-code",
                    forgot: "/forgot-password",
                    forgetWithRecovery: "/forget-with-recovery",
                    email: "/email-sent",
                    reset: "/reset/:code",
                    register: "/register"
                };
            }
        })()}/>;
    };
}